// extracted by mini-css-extract-plugin
export var card = "Card-module--card--9eMFu";
export var txtContainer = "Card-module--txtContainer--XocHf";
export var cardImg = "Card-module--cardImg--w2PuD";